module.exports = __webpack_public_path__ + "static/img/solutionDetailPic1.c7c23bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic1.png
// module id = m/kD
// module chunks = 1